module.exports = __webpack_public_path__ + "img/occidental-room.9b0b1e92.jpg";